export default {
      id: "loudspeaker-usage",
      viewBox: "0 0 106 86",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#loudspeaker",
      toString: function () {
        return this.url;
      }
    }